import { isShippingEligibleTrackId } from "./game/legacyTrackEligibility";

// Canonical application route boundary: only one mode starts a world renderer.
// Battle is reached from the normal menu; both routes share the same Vite build.
const query = new URLSearchParams(location.search);
const requestedTrack = query.get("track");
if (query.get("mode") !== "battle" && requestedTrack && query.get("qa") !== "1" && !isShippingEligibleTrackId(requestedTrack)) {
  // Old bookmarks remain explicit, never a silent Malt Mountain fallback.
  // Source diagnostics retain qa=1 access; this does not put imports in menus.
  const notice = document.createElement("main");
  notice.id = "course-unavailable";
  notice.style.cssText = "max-width:38rem;margin:12vh auto;padding:2rem;color:#f7edce;background:#172d2b;border:1px solid #d8b86b;border-radius:1rem;font:1.1rem/1.6 system-ui";
  const heading = document.createElement("h1"); heading.textContent = "COURSE UNAVAILABLE";
  const message = document.createElement("p"); message.textContent = "This imported course has been removed from normal play while its corners and borders remain unqualified. Your saved records are preserved. Choose an authored BeerKart course from the menu.";
  const back = document.createElement("a"); back.href = "/"; back.textContent = "BACK TO MENU"; back.style.color = "#f4d47b";
  notice.append(heading, message, back);
  document.body.replaceChildren(notice);
  back.focus();
} else if (query.get("mode") === "battle") {
  void import("./battle/main");
} else {
  void import("./main");
}
